import keys from 'lodash/keys';
import pickBy from 'lodash/pickBy';

export const makeIdentifiers = (mapping: Record<string, boolean>) => keys(pickBy(mapping, Boolean));

export const makeDisabled = (disabled: string[]): Record<string, boolean> =>
    disabled.reduce(
        (mapping, id) => ({
            ...mapping,
            [id]: true,
        }),
        {},
    );
